import React, { useRef, useCallback, useState } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import scrollbar from '../../styles/scrollbar';

const useStyles = createUseStyles({
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(10,6,3,0.6)',
    zIndex: 10,
    display: ({ open }) => open ? 'block' : 'none',
    opacity: ({ open }) => open ? 1 : 0,
    transition: 'opacity 0.3s ease',
  },
  sheet: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: ({ theme }) => theme.colorPanel,
    borderTop: '1px solid #6b4622',
    borderRadius: '16px 16px 0 0',
    zIndex: 11,
    transform: ({ open, translateY }) =>
      open ? `translateY(${translateY}px)` : 'translateY(100%)',
    transition: ({ dragging }) => dragging ? 'none' : 'transform 0.3s ease',
    maxHeight: '80vh',
    overflowY: 'auto',
    ...scrollbar,
    touchAction: 'none',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1), 0 -12px 40px rgba(0,0,0,0.5)',
  },
  handle: {
    width: '44px',
    height: '5px',
    background: '#6b4622',
    borderRadius: '3px',
    margin: '12px auto 16px',
    cursor: 'grab',
    touchAction: 'none',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.18)',
  },
});

function BottomSheet({ open, onClose, children }) {
  const theme = useTheme();
  const [translateY, setTranslateY] = useState(0);
  const [dragging, setDragging] = useState(false);
  const startY = useRef(0);

  const handleTouchStart = useCallback((e) => {
    setDragging(true);
    startY.current = e.touches[0].clientY;
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!dragging) return;
    const dy = e.touches[0].clientY - startY.current;
    setTranslateY(Math.max(0, dy));
  }, [dragging]);

  const handleTouchEnd = useCallback(() => {
    setDragging(false);
    if (translateY > 100) {
      onClose();
    }
    setTranslateY(0);
  }, [translateY, onClose]);

  const classes = useStyles({ theme, open, translateY, dragging });

  if (!open) return null;

  return (
    <>
      <div className={classes.overlay} onClick={onClose} />
      <div
        className={classes.sheet}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className={classes.handle} />
        {children}
      </div>
    </>
  );
}

export default BottomSheet;
